<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Group from '$lib/icons/group-svgrepo-com.svelte';
	import HostWebsite from '$lib/icons/host-website-se-svgrepo-com.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#98B1D8] mt-4 text-white"><b>WP 3</b></span>
	<div class="flex">
		<h1 class="content-heading">Climate Services Gateway through co-production</h1>
		<HostWebsite />
	</div>

	<blockquote class="content-blockquote">
		he objective of this WP is the development of a web-based Climate Service Gateway with and for
		scientists and stakeholders, which will serve as a platform for easy access to projections of
		regional climate change and climate impact indicators related to water and food security and
		biodiversity conservation.
	</blockquote>

	<div class="flex pt-10">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team/#sophie_biskop">Sophie Biskop (Uni Jena)</a>
		</div>
	</div>

	<div class="flex pt-4">
		<Group />
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#uni_jena">Uni Jena</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gerics">GERICS</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#wits_gci">WITS-GCI</a></div>
	</div>

	<h2 class="h4 pt-10 pb-2">Objectives</h2>
	The objective of this WP is the development of a web-based Climate Service Gateway with and for scientists
	and stakeholders, which will serve as a platform for easy access to projections of regional climate
	change and climate impact indicators related to water and food security and biodiversity conservation.
	The services provided will be based on the need identified in the stakeholder engagement, and their
	fitness-for-use will be assessed by ongoing engagement with the user community. Addressing the need
	for spatially explicit and problem-tailored information on future climate, the system will provide
	functions for accessing climate projection data (WP1) at user-defined points/areas of interest and
	for the dynamic calculation of related climate indicators (WP2) on demand. Moreover, the system will
	provide functions to initiate and control the processing of ensembles of projections, to manage and
	share the outputs of user-defined data analyses, and to visualize results by means of graphs and maps.
	These outputs will be designed with the users to ensure that the visualizations are indeed useful.
	General metadata and detailed provenance information will be stored for each created dataset to ease
	further use. It should be noted that a climate service such as the one to be developed here does not
	currently exist in the SADC region, yet there is an immense demand for such a capability. An important
	stakeholder in the co-production process to develop the Climate Services Gateway is SASSCAL itself.
</div>
